import { Alert, Box, Typography } from '@mui/material';

interface PlaceholderPageProps {
  title: string;
  description?: string;
}

/**
 * Stands in for a not-yet-implemented module page. Used by routes registered
 * for backend modules whose UI hasn't been built yet — keeps the nav drawer
 * functional so the structure stays visible.
 */
export function PlaceholderPage({ title, description }: PlaceholderPageProps) {
  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        {title}
      </Typography>
      <Alert severity="info">
        {description ??
          'This screen is not implemented yet. The backend module exists; the UI is scheduled for a future iteration.'}
      </Alert>
    </Box>
  );
}
